var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiSalad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-ui--salad_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-ui--salad_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.852 13.707l-.984-2.767a3.005 3.005 0 01-.985-.78 2.957 2.957 0 01-.574-1.11l-.636-2.393h12.66l-.636 2.393a2.956 2.956 0 01-.574 1.11c-.27.326-.598.586-.985.78l-.978 2.767H4.852zm.723-.946h4.856l.546-1.497H5.029l.546 1.498zm-.25-2.443h5.357c.492 0 .927-.138 1.304-.414.377-.276.623-.634.738-1.074l.339-1.227H2.95l.332 1.227c.115.44.361.798.738 1.074s.812.414 1.304.414zm7.745-3.661h-1v-.903a.838.838 0 00-.278-.639.964.964 0 00-.682-.259 1.11 1.11 0 00-.54.143 1.154 1.154 0 00-.423.397H8.636L8.5 4.932c-.098-.336-.246-.586-.443-.75a1.066 1.066 0 00-.706-.247c-.234 0-.44.056-.618.168-.178.112-.318.27-.42.472l-.272.584H4.737a.805.805 0 00-.571.215.697.697 0 00-.23.531v.752h-1v-.752c0-.469.176-.868.53-1.197.353-.33.794-.494 1.321-.494.072 0 .16.006.267.017.107.012.213.022.319.031a2.17 2.17 0 011.98-1.273c.503 0 .941.149 1.315.446.373.298.639.709.796 1.232.215-.242.462-.429.74-.56.277-.13.574-.196.89-.196.552 0 1.02.18 1.403.538.382.359.573.794.573 1.305v.903z"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--salad-b6cc0efd6efeacd4315ff9d17e7783f0.svg";
export { SvgIconUiSalad as Component };